<template>
  <!-- 首页容器 -->
  <div class="home-container">
    <!-- SVG图标定义区域，设置为不显示 -->
    <svg xmlns="http://www.w3.org/2000/svg" style="display: none">
      <!-- 产品介绍图标 -->
      <symbol id="icon-product" viewBox="0 0 24 24">
        <path
          d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM8 15h8v2H8v-2zm0-4h8v2H8v-2zm0-4h8v2H8V7zm-4 0h2v2H4V7zm0 4h2v2H4v-2zm0 4h2v2H4v-2z"
          fill="currentColor"
        />
      </symbol>

      <!-- 申请流程图标 -->
      <symbol id="icon-process" viewBox="0 0 24 24">
        <path
          d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7zm-4 6h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"
          fill="currentColor"
        />
      </symbol>

      <!-- 预约申请图标 -->
      <symbol id="icon-appointment" viewBox="0 0 24 24">
        <path
          d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7v-5z"
          fill="currentColor"
        />
      </symbol>
    </svg>
    <!-- 顶部导航栏 -->
    <!-- 轮播图区域 -->
    <div class="banner">
      <!-- Element UI轮播组件 -->
      <el-carousel indicator-position="outside">
        <el-carousel-item>
          <img
            src="@/assets/img/banner1.jpg"
            alt=""
          />
        </el-carousel-item>
        <el-carousel-item>
          <img
            src="@/assets/img/banner2.jpg"
            alt=""
          />
        </el-carousel-item>
        <el-carousel-item>
          <img
            src="@/assets/img/banner3.png"
            alt=""
          />
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 产品信息 -->
    <div class="box-product">
      <router-link to="/product" class="product-item">
        <svg class="icon"><use xlink:href="#icon-product" /></svg>
        <h3>产品介绍</h3>
        <p>全面的金融产品介绍<br />助您找到最适合的选择</p>
      </router-link>
      <router-link to="/process" class="product-item">
        <svg class="icon"><use xlink:href="#icon-process" /></svg>
        <h3>申请流程</h3>
        <p>简单便捷的申请流程<br />专业顾问全程指导</p>
      </router-link>
      <router-link to="/apply" class="product-item">
        <svg class="icon"><use xlink:href="#icon-appointment" /></svg>
        <h3>预约申请</h3>
        <p>在线预约业务办理<br />省时省力更便捷</p>
      </router-link>
    </div>

    <!-- 添加小微企业贷款产品展示 -->
    <div class="micro-loan-section">
      <div class="section-header">
        <h2>小微企业贷款产品</h2>
        <p class="subtitle">助力小微企业发展，提供多样化融资解决方案</p>
      </div>

      <div class="loan-products">
        <div class="loan-card" v-for="item in productList" :key="item._id">
          <div class="loan-header">
            <div class="loan-title">{{ item.name }}</div>
          </div>
          <div class="loan-info">
            <div class="info-item">
              <span class="label">额度最高</span>
              <span class="value">{{ item.maxAmount }}万元</span>
            </div>
            <div class="info-item">
              <span class="label">最长期限</span>
              <span class="value">{{ item.maxTerm }}年</span>
            </div>
          </div>
          <div class="loan-desc">
            {{ item.targets }}
          </div>
          <div class="loan-footer">
            <el-button
              type="primary"
              size="small"
              @click="handleApply(item)"
              class="apply-btn"
              >立即申请</el-button
            >
            <el-button type="text" @click="viewDetail(item)" class="detail-btn"
              >查看详情 <i class="el-icon-arrow-right"></i
            ></el-button>
          </div>
        </div>
      </div>
      <router-link to="/product" class="more-prduct">更多产品</router-link>
    </div>

        <!-- 贷款估算工具区域 -->
    <div class="loan-calculator-section">
      <div class="section-header">
        <h2>贷款计算工具</h2>
        <p class="subtitle">快速估算您的贷款额度和还款计划</p>
      </div>

      <div class="calculator-container">
        <!-- 企业贷款工具 -->
        <div class="calculator-card">
          <h3 class="calculator-title">企业贷款工具</h3>
          <div class="calculator-form">
            <div class="form-item">
              <label>在我行存款余额 (万元)</label>
              <el-input
                v-model="businessLoan.deposit"
                placeholder="请输入金额"
              ></el-input>
            </div>
            <div class="form-item">
              <label>在我行理财余额 (万元)</label>
              <el-input
                v-model="businessLoan.financial"
                placeholder="请输入金额"
              ></el-input>
            </div>
            <div class="form-item">
              <label>近一年销售额 (万元)</label>
              <el-input
                v-model="businessLoan.sales"
                placeholder="请输入金额"
              ></el-input>
            </div>
            <div class="form-item">
              <label>近一年纳税额 (万元)</label>
              <el-input
                v-model="businessLoan.tax"
                placeholder="请输入金额"
              ></el-input>
            </div>
            <div class="form-action">
              <el-button type="primary" @click="calculateBusinessLoan"
                >点击估算</el-button
              >
            </div>
          </div>
          <div class="calculator-result">
            <p class="result-title">
              预估可贷金额:
              <span class="result-value">{{ businessLoan.result }}</span> 万元
            </p>
            <p class="result-note">注: 具体以银行审批结果为准</p>
          </div>
        </div>

        <!-- 贷款还款估算 -->
        <div class="calculator-card">
          <h3 class="calculator-title">贷款还款估算</h3>
          <div class="calculator-form">
            <div class="form-item">
              <label>贷款本金 (万元)</label>
              <el-input
                v-model="repayment.principal"
                placeholder="请输入金额"
              ></el-input>
            </div>
            <div class="form-item">
              <label>年利率 (%)</label>
              <el-select v-model="repayment.rate" placeholder="请选择">
                <el-option label="4.35" value="4.35"></el-option>
                <el-option label="4.75" value="4.75"></el-option>
                <el-option label="5.00" value="5.00"></el-option>
                <el-option label="5.25" value="5.25"></el-option>
              </el-select>
            </div>
            <div class="form-item">
              <label>贷款期限 (年)</label>
              <el-input
                v-model="repayment.term"
                placeholder="请输入年限"
              ></el-input>
            </div>
            <div class="form-item">
              <label>还款方式</label>
              <el-select v-model="repayment.method" placeholder="请选择">
                <el-option label="先息后本" value="interest_first"></el-option>
                <el-option label="等额本息" value="equal_payment"></el-option>
                <el-option label="等额本金" value="equal_principal"></el-option>
              </el-select>
            </div>
            <div class="form-action">
              <el-button type="primary" @click="calculateRepayment"
                >点击估算</el-button
              >
            </div>
          </div>
          <div class="calculator-result">
            <p class="result-item">
              每月还款额:
              <span class="result-value">{{ repayment.monthlyPayment }}</span>
              元
            </p>
            <p class="result-item">
              总利息:
              <span class="result-value">{{ repayment.totalInterest }}</span> 元
            </p>
            <p class="result-item">
              总还款额:
              <span class="result-value">{{ repayment.totalPayment }}</span> 元
            </p>
            <p class="result-note">
              注: 计算结果仅供参考，具体以实际贷后批准为准
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 公告和政策区域 -->
    <div class="notice-section">
      <div class="notice-container">
        <div class="notice-tabs">
          <div class="tab-buttons">
            <a
              href="https://www.hnnx.com/sitesources/hnnx/page_pc/xwzx/xyzx/list1.html"
              target="_blank"
              class="tab-btn active"
              >公告资讯</a
            >
            <a
              href="https://www.hnnx.com/sitesources/hnnx/page_pc/zcfg/list1.html"
              target="_blank"
              class="tab-btn"
              >政策法规</a
            >
          </div>
          <div class="notice-content">
            <div class="notice-box">
              <div class="notice-list">
                <div
                  v-for="item in noticeList"
                  :key="item._id"
                  class="notice-item"
                >
                  <a :href="item.url" target="_blank" class="title">{{
                    item.title
                  }}</a>
                  <span class="date">{{ item.release_time }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 导入API接口函数
import { getInfo } from "@/api";
export default {
  name: "Home", // 组件名称
  data() {
    return {
      activeTab: "notice", // 当前激活的标签页，'notice'表示公告，'policy'表示政策
      // 企业贷款工具数据对象
      businessLoan: {
        deposit: "", // 存款余额
        financial: "", // 理财余额
        sales: "", // 销售额
        tax: "", // 纳税额
        result: "0", // 估算结果
      },
      // 贷款还款估算数据对象
      repayment: {
        principal: "", // 贷款本金
        rate: "4.35", // 年利率，默认4.35%
        term: "5", // 贷款期限，默认5年
        method: "interest_first", // 还款方式，默认先息后本
        monthlyPayment: "0.00", // 每月还款额
        totalInterest: "0.00", // 总利息
        totalPayment: "0.00", // 总还款额
      },
      productList: [], // 产品列表数据
      noticeList: [], // 公告列表数据
    };
  },
  methods: {
    // 计算企业贷款额度
    calculateBusinessLoan() {
      // 验证是否至少填写了一项数据
      if (
        !this.businessLoan.deposit &&
        !this.businessLoan.financial &&
        !this.businessLoan.sales &&
        !this.businessLoan.tax
      ) {
        this.$message.warning("请至少填写一项数据");
        return;
      }

      // 解析输入值，如果为空则默认为0
      const deposit = parseFloat(this.businessLoan.deposit) || 0;
      const financial = parseFloat(this.businessLoan.financial) || 0;
      const sales = parseFloat(this.businessLoan.sales) || 0;
      const tax = parseFloat(this.businessLoan.tax) || 0;

      // 计算贷款额度，使用加权计算公式
      let result = deposit * 1.5 + financial * 1.2 + sales * 0.3 + tax * 2.0;
      result = Math.min(result, 1000); // 设置最高额度上限为1000万元

      // 格式化结果为两位小数
      this.businessLoan.result = result.toFixed(2);
    },

    // 计算贷款还款
    calculateRepayment() {
      // 验证必填字段
      if (!this.repayment.principal || !this.repayment.term) {
        this.$message.warning("请填写完整的贷款信息");
        return;
      }

      // 准备计算参数
      const principal = parseFloat(this.repayment.principal) * 10000; // 将万元转换为元
      const monthlyRate = parseFloat(this.repayment.rate) / 100 / 12; // 计算月利率
      const totalMonths = parseInt(this.repayment.term) * 12; // 计算总月数

      let monthlyPayment = 0; // 每月还款额
      let totalInterest = 0; // 总利息
      let totalPayment = 0; // 总还款额

      // 根据不同还款方式计算
      if (this.repayment.method === "equal_payment") {
        // 等额本息计算公式
        monthlyPayment =
          (principal * monthlyRate * Math.pow(1 + monthlyRate, totalMonths)) /
          (Math.pow(1 + monthlyRate, totalMonths) - 1);
        totalPayment = monthlyPayment * totalMonths; // 总还款额
        totalInterest = totalPayment - principal; // 总利息
      } else if (this.repayment.method === "equal_principal") {
        // 等额本金计算
        const monthlyPrincipal = principal / totalMonths; // 每月还款本金
        const firstMonthInterest = principal * monthlyRate; // 第一个月的利息
        monthlyPayment = monthlyPrincipal + firstMonthInterest; // 第一个月的还款额

        // 总利息计算公式
        totalInterest = (principal * monthlyRate * (totalMonths + 1)) / 2;
        totalPayment = principal + totalInterest; // 总还款额
      } else if (this.repayment.method === "interest_first") {
        // 先息后本计算
        monthlyPayment = principal * monthlyRate; // 每月利息
        totalInterest = monthlyPayment * totalMonths; // 总利息
        totalPayment = principal + totalInterest; // 总还款额
      }

      // 格式化结果为两位小数
      this.repayment.monthlyPayment = monthlyPayment.toFixed(2);
      this.repayment.totalInterest = totalInterest.toFixed(2);
      this.repayment.totalPayment = totalPayment.toFixed(2);
    },
    
    // 获取推荐产品列表
    getProduct() {
      // 调用API获取产品数据
      getInfo({
        model: "product", // 模型名称
        condition: {
          isRecommend: true, // 只获取推荐产品
        },
        page: 1, // 页码
        pagesize: 20, // 每页条数
      }).then((res) => {
        if (res.status == 200) {
          this.productList = res.data.data; // 设置产品列表数据
        }
      });
    },
    
    // 处理产品申请
    handleApply(item) {
      // 获取用户登录状态
      let access_token = localStorage.getItem("access_token");
      let isUserAuth = localStorage.getItem("isUserAuth");
      
      // 检查用户是否已登录
      if (access_token && isUserAuth) {
        // 已登录，跳转到申请页面
        this.$router.push({
          path: `/apply/` + item._id, // 带上产品ID
        });
      } else {
        // 未登录，提示用户并跳转到登录页面
        this.$message({
          message: "请先登录账号进行产品申请！",
          type: "warning",
        });
        this.$router.push({
          path: "/login",
        });
      }
    },
    
    // 查看产品详情
    viewDetail(item) {
      let id = item._id; // 获取产品ID
      // 跳转到产品详情页
      this.$router.push({
        path: `/productdetail/` + id,
      });
    },
    
    // 获取公告列表
    getNotice() {
      // 调用API获取公告数据
      getInfo({
        model: "notice", // 模型名称
        condition: {}, // 查询条件
        page: 1, // 页码
        pagesize: 20, // 每页条数
      }).then((res) => {
        if (res.status == 200) {
          this.noticeList = res.data.data; // 设置公告列表数据
        }
      });
    },
  },
  // 组件创建时执行
  created() {
    this.getProduct(); // 获取产品列表
    this.getNotice(); // 获取公告列表
  },
};
</script>

<style scoped>
.home-container {
  width: 1200px;
  margin: 0 auto;
}

.banner {
  width: 100%;
  overflow: hidden;
}

.banner img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 产品信息  */

.box-product {
  display: flex;
  justify-content: space-between;
  gap: 50px;
  perspective: 1000px;
}
.box-product .product-item {
  flex: 1;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 15px;
  padding: 20px 30px;
  text-align: center;
  height: 140px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  font-size: 1.3em;
  color: #34495e;
  position: relative;
  overflow: hidden;
  backdrop-filter: blur(5px);
}

.box-product .product-item svg {
  width: 48px;
  height: 48px;
  margin-bottom: 10px;
  color: #21ab4b;
}
.box-product .product-item::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, #3498db, #2ecc71);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}
.box-product .product-item:hover {
  transform: translateY(-10px);
}
.box-product .product-item:hover::before {
  transform: scaleX(1);
}
.box-product .product-item h3 {
  color: #333;
  font-size: 18px;
}

.box-product .product-item p {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
}

/* 贷款计算工具样式 */
.loan-calculator-section {
  padding: 0 0 40px;
  background: #fff;
}

.calculator-container {
  display: flex;
  justify-content: space-between;
  gap: 30px;
  flex-wrap: wrap;
  margin-top: 30px;
}

.calculator-card {
  width: 500px;
  background: #f9f9f9;
  border-radius: 10px;
  padding: 25px;
  border: 1px solid #eee;
}

.calculator-title {
  font-size: 20px;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
  position: relative;
}

.calculator-title:after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 50px;
  height: 3px;
  background: #21ab4b;
}

.calculator-form {
  margin-top: 25px;
}

.form-item {
  margin-bottom: 15px;
}

.form-item label {
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-size: 14px;
}

.form-action {
  margin-top: 20px;
  text-align: center;
}

.calculator-result {
  height: 100px;
  margin-top: 20px;
  padding: 15px;
  background: #f0f9eb;
  border-radius: 5px;
  border-left: 4px solid #67c23a;
}

.result-title {
  font-size: 16px;
  color: #333;
  margin-bottom: 10px;
}

.result-item {
  margin-bottom: 8px;
  color: #333;
}

.result-value {
  color: #21ab4b;
  font-weight: bold;
  font-size: 18px;
}

.result-note {
  font-size: 12px;
  color: #999;
  margin-top: 10px;
}

/* 小微企业贷款产品样式 */
.micro-loan-section {
  padding: 40px 0;
  background: #f9f9f9;
  margin: 40px 0;
}

.section-header {
  text-align: center;
  margin-bottom: 30px;
}

.section-header h2 {
  font-size: 28px;
  color: #333;
  margin-bottom: 10px;
}

.subtitle {
  color: #666;
  font-size: 16px;
}

.loan-products {
  display: flex;
  justify-content: center;
  gap: 20px;
  padding: 0 20px;
}

.loan-card {
  width: 270px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  padding: 20px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.loan-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

.loan-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.loan-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.loan-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.info-item {
  display: flex;
  flex-direction: column;
}

.label {
  font-size: 12px;
  color: #666;
  margin-bottom: 5px;
}

.value {
  font-size: 16px;
  color: #21ab4b;
  font-weight: bold;
}

.loan-desc {
  color: #666;
  font-size: 14px;
  line-height: 1.5;
  height: 42px;
  overflow: hidden;
  margin-bottom: 15px;
}

.loan-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.apply-btn {
  background: #21ab4b;
  border-color: #21ab4b;
}

.apply-btn:hover {
  background: #24bb51;
  border-color: #24bb51;
}

.detail-btn {
  color: #666;
}

.detail-btn:hover {
  color: #21ab4b;
}

.more-prduct {
  margin: 30px auto 0;
  width: 100px;
  color: #fff;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  background-color: #21ab4b;
  display: block;
}

.more-prduct:hover {
  opacity: 0.9;
}

/* 贷款详情弹窗样式 */
/deep/ .el-button--primary {
  background-color: #21ab4b;
  border-color: #21ab4b;
}

.notice-section {
  padding: 20px 0;
  background: #fff;
}

.notice-container {
  width: 1200px;
  margin: 0 auto;
  padding: 20px;
  background: #fff;
  box-sizing: border-box;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.notice-tabs {
  width: 100%;
}

.tab-buttons {
  display: flex;
  border-bottom: 1px solid #ddd;
  margin-bottom: 20px;
}

.tab-btn {
  padding: 10px 20px;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 16px;
  position: relative;
}

.tab-btn:hover {
  color: #21ab4b;
}

.tab-btn:hover::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 2px;
  background: #21ab4b;
}

.tab-btn.active {
  font-weight: bold;
  font-size: 20px;
}

.link-area {
  padding: 10px;
  background: #f5f5f5;
  margin-bottom: 20px;
  font-size: 14px;
  color: #666;
}

.notice-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.notice-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0;
}

.notice-item .title {
  cursor: pointer;
  flex: 1;
}

.notice-item .title:hover {
  color: #21ab4b;
}

.notice-item .date {
  color: #999;
  font-size: 14px;
}
</style>